import React from "react";
import { useCustomQuery } from "utilities/hookutils";
import * as ReactHighcharts from "react-highcharts";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import { serializeToQueryString } from "utilities/queryString";
import { routes } from "utilities/routing/generatedRoutes";

const formatQuarterStart = (item: server.dto.SubscriptionChurnAndGrowth) => {
  const month = ((item.quarter - 1) * 3) + 1;
  return `${item.year}-${month.toString().padStart(2, "0")}-01`;
};

const openGrowthInNewTab = (item: server.dto.SubscriptionChurnAndGrowth) => {
  const queryString = serializeToQueryString({
    period: {
      period: "perQuarter",
      selectionStart: formatQuarterStart(item),
      selectBySendOrDueDate: "customerSinceDate"
    }
  });
  window.open(`${routes.client_ListAdminOne().absolute}?${queryString}`, "_blank");
};

const openChurnInNewTab = (item: server.dto.SubscriptionChurnAndGrowth) => {
  const queryString = serializeToQueryString({
    period: {
      period: "perQuarter",
      selectionStart: formatQuarterStart(item),
      selectBySendOrDueDate: "customerChurnDate"
    }
  });
  window.open(`${routes.client_ListAdminOne().absolute}?${queryString}`, "_blank");
};

const GrowthChurnPanel = () => {
  const metrics = useCustomQuery({
    queryKey: ["subscriptionChurnAndGrowth"],
    queryFn: () => window.CoreApi.AdminOne.SubscriptionChurnAndGrowth().then(res => res.data.data),
    initialData: [],
  });
  const data = metrics.data ?? [];

  return <SectionPanel.Panel
    collapsible={{ start: "closed", uniqueRowId: "growth-churn-panel", persist: true }}
    header={<PanelSegment.Title title={"Growth / Churn"} />}
  >
    <ReactHighcharts
      config={{
        chart: {
          style: {
            fontFamily: "inherit"
          },
          type: "column",
          backgroundColor: "transparent"
        },
        plotOptions: {
          column: {
            borderColor: "transparent",
            cursor: "pointer",
            dataLabels: {
              style: {
                color: "var(--text-color-light)"
              }
            }
          }
        },
        legend: {
          itemStyle: {
            color: "var(--text-color-light)",
          },
          itemHoverStyle: {
            color: "var(--text-color)",
          },
          itemHiddenStyle: {
            color: "var(--text-color-lighter)",
          },
        },
        series: [
          {
            name: "Growth",
            data: data.map(item => ({
              y: item.growth,
              events: {
                click: () => {
                  openGrowthInNewTab(item);
                  return false;
                }
              }
            })),
            color: "var(--green)"
          },
          {
            name: "Churn",
            data: data.map(item => ({
              y: item.churn,
              events: {
                click: () => {
                  openChurnInNewTab(item);
                  return false;
                }
              }
            })),
            color: "var(--error-color)"
          }
        ],
        title: {
          text: ""
        },
        xAxis: {
          labels: {
            style: {
              color: "var(--text-color-light)"
            }
          },
          categories: data.map(item => `${item.year} Q${item.quarter}`),
        },
        yAxis: {
          labels: {
            style: {
              color: "var(--text-color-light)"
            }
          },
          title: {
            text: "nr of clients",
            style: {
              color: "var(--text-color-light)"
            }
          }
        },
        credits: {
          enabled: false
        }
      }}
    />
  </SectionPanel.Panel>;
};

export default GrowthChurnPanel;
